import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { ListaFormaDefault } from '@app/shared';

@Injectable()
export class DuplicateProcessDataService {

  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Duplica el tramite
   *
   * @param {number} idorigin
   * @param {number} idDestination
   * @param {boolean} copyComplete
   * @param {*} activities
   * @param {boolean} copyAdvanced
   * @returns {Observable<boolean>}
   * @memberof DuplicateProcessDataService
   */
  duplicateProcess(
    idorigin: number,
    idDestination: number,
    copyComplete: boolean,
    activities: any,
    copyAdvanced: boolean
  ): Observable<boolean> {

    const configData = {
      tramite_origen: idorigin,
      tramite_destino: idDestination,
      copia_completa: copyComplete,
      actividades: activities,
      copia_avanzada: copyAdvanced
    };

    return new Observable(obs => {
      this.http.skipErrorHandler()
        .post(this.api.get('duplicateDefaultTramite'), configData, {
          observe: 'response'
        })
        .subscribe(
          res => {
            if (res.status === 201) {
              obs.next(true);
              this.toastr.success('Trámite duplicado con exito.', 'Operación exitosa');
            } else {
              obs.next(false);
            }
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error('Ha ocurrido un error inesperado');
            }
            obs.next(false);
          }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/duplicate-process/shared/duplicate-process.data.service.ts